import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66978ae1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-5 pb-5 container" }
const _hoisted_2 = { class: "header d-flex justify-content-between align-itens-center col" }
const _hoisted_3 = { class: "m-0" }
const _hoisted_4 = { class: "container-form mb-4" }
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group mb-3 w-25" }
const _hoisted_8 = { for: "selectUser" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = { class: "row mt-3" }
const _hoisted_11 = { class: "form-group w-25" }
const _hoisted_12 = { for: "initDate" }
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = { class: "form-group w-25" }
const _hoisted_15 = { for: "finishDate" }
const _hoisted_16 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_17 = { class: "form-group w-50" }
const _hoisted_18 = { for: "daysWeek" }
const _hoisted_19 = { class: "row justify-content-around" }
const _hoisted_20 = ["for"]
const _hoisted_21 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_22 = { class: "row mt-3" }
const _hoisted_23 = { class: "form-group mb-3 w-25" }
const _hoisted_24 = { for: "checkIn" }
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = { class: "form-group mb-3 w-25" }
const _hoisted_27 = { for: "checkOut" }
const _hoisted_28 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_29 = { class: "row row-delete" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_ds_button = _resolveComponent("ds-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.scheduleId ? _ctx.$t('schedule.edit') : _ctx.$t('schedule.register')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('schedule.fields.name')), 1),
            _createVNode(_component_AutoComplete, {
              id: "selectUser",
              name: "selectUser",
              placeholder: _ctx.$t('schedule.fields.info'),
              modelValue: _ctx.pickedUser,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pickedUser) = $event)),
              dropdown: "",
              suggestions: _ctx.users,
              onComplete: _ctx.getUser,
              field: "name",
              disabled: _ctx.disabled,
              class: _normalizeClass(`w-100 ${_ctx.v$.form.schedule.userId.$error ? 'p-invalid' : ''}`)
            }, null, 8, ["placeholder", "modelValue", "suggestions", "onComplete", "disabled", "class"]),
            (_ctx.v$.form.schedule.userId.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('group.fields.start')), 1),
            _createVNode(_component_Calendar, {
              modelValue: _ctx.form.schedule.initDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.schedule.initDate) = $event)),
              class: _normalizeClass([`w-100 ${_ctx.v$.form.schedule.initDate.$error ? 'p-invalid' : ''}`, "d-block expiration-input"]),
              "min-date": new Date(),
              id: "initDate",
              "date-format": "dd/mm/yy",
              name: "initDate",
              disabled: _ctx.disabled,
              placeholder: "DD/MM/AAAA"
            }, null, 8, ["modelValue", "class", "min-date", "disabled"]),
            (_ctx.v$.form.schedule.initDate.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('group.fields.finish')), 1),
            _createVNode(_component_Calendar, {
              modelValue: _ctx.form.schedule.finishDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.schedule.finishDate) = $event)),
              class: _normalizeClass([`w-100 ${_ctx.v$.form.schedule.finishDate.$error ? 'p-invalid' : ''}`, "d-block expiration-input"]),
              minDate: new Date(),
              id: "finishDate",
              "date-format": "dd/mm/yy",
              name: "finishDate",
              placeholder: "DD/MM/AAAA",
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "class", "minDate", "disabled"]),
            (_ctx.v$.form.schedule.finishDate.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_16, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('group.fields.weekDays')), 1),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (day) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: day.value,
                  class: "checkdiv d-flex align-items-center flex-column"
                }, [
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.selectedDays,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedDays) = $event)),
                    InputId: day.name,
                    id: day.name,
                    label: _ctx.navigator == 'pt-BR' ? day.label : day.enLabel,
                    name: day.name,
                    value: day.value,
                    disabled: _ctx.disabled
                  }, null, 8, ["modelValue", "InputId", "id", "label", "name", "value", "disabled"]),
                  _createElementVNode("label", {
                    class: "checkLabel",
                    for: day.name
                  }, _toDisplayString(_ctx.navigator == 'pt-BR' ? day.label : day.enLabel), 9, _hoisted_20)
                ]))
              }), 128))
            ]),
            (_ctx.noDaysSelected)
              ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('schedule.fields.startHour')), 1),
            _createVNode(_component_Calendar, {
              id: "checkIn",
              name: "checkIn",
              placeholder: "HH:MM",
              disabled: _ctx.disabled,
              timeOnly: "",
              modelValue: _ctx.form.schedule.calendarList[0].checkIn,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.schedule.calendarList[0].checkIn) = $event)),
              class: _normalizeClass(`w-100 ${_ctx.v$.form.schedule.calendarList[0].checkOut.$error ? 'p-invalid' : ''}`)
            }, null, 8, ["disabled", "modelValue", "class"]),
            (_ctx.v$.form.schedule.calendarList[0].checkIn.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_25, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('schedule.fields.finishHour')), 1),
            _createVNode(_component_Calendar, {
              id: "checkOut",
              name: "checkOut",
              placeholder: "HH:MM",
              disabled: _ctx.disabled,
              timeOnly: "",
              modelValue: _ctx.form.schedule.calendarList[0].checkOut,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.schedule.calendarList[0].checkOut) = $event)),
              class: _normalizeClass(`w-100 ${_ctx.v$.form.schedule.calendarList[0].checkOut.$error ? 'p-invalid' : ''}`)
            }, null, 8, ["disabled", "modelValue", "class"]),
            (_ctx.v$.form.schedule.calendarList[0].checkOut.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_28, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_ds_button, {
            type: "tertiary",
            text: _ctx.$t('schedule.delete'),
            class: "delete-schedule mt-3",
            leftIcon: "delete",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmDelete(_ctx.scheduleId)))
          }, null, 8, ["text"])
        ]),
        _createVNode(_component_ds_button, {
          type: "secondary",
          text: _ctx.$t('utils.back'),
          class: "float-start me-3 button",
          onClick: _cache[7] || (_cache[7] = () => _ctx.$router.push({ name: 'Schedule' }))
        }, null, 8, ["text"]),
        _createVNode(_component_ds_button, {
          type: "primary",
          text: _ctx.$t('utils.confirm'),
          class: "float-start button",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sendSchedule()))
        }, null, 8, ["text"])
      ])
    ])
  ]))
}